<template>
  <Layout style="background-color: '#f5f5f5'; height:100%;" v-if="isPageReady">
    <MgnNavbar />
    <Layout style="height:100%;">
      <Header class="sub-header">
        <div class="sub-header-items left">
          <h3>{{audioRoom.title}}</h3>
        </div>
        <div class="sub-header-items right">
          <span>{{audioRoom.status}}</span>
          <Button v-if="audioRoom.status == 'completed'" type="success" @click="initRoom">Init Room</Button>
          <Button type="default" @click="startWowzaRecording(webcast._id)">Start Recording</Button>
          <Button
            v-if="!audioRoom.isSpeakersConnected"
            type="primary"
            @click="connectSpeakers"
          >Connect Speakers</Button>
          <Button
            v-if="audioRoom.isSpeakersConnected"
            type="error"
            @click="disconnectSpeakers"
          >Disconnect Speakers</Button>
          <Button type="primary" @click="toggleHoldAudioRoom">
            <span v-if="!audioRoom.isHold">Hold AudioRoom</span>
            <span v-if="audioRoom.isHold">unHold AudioRoom</span>
          </Button>
          <Button
            v-if="audioRoom.status != 'in-progress'"
            type="success"
            @click="startAudioRoom"
          >Start Meeting</Button>
          <Button
            v-if="audioRoom.status == 'in-progress'"
            type="error"
            @click="endAudioRoom"
          >End Meeting</Button>
          <!--
            <Button @click="connectToOperatorRoom">Connect</Button>
            <Button @click="disconnectToOperatorRoom">Disconnect</Button>
          -->
        </div>
      </Header>
      <Content style="margin-top:120px; background-color: #f5f5f5; height:100%;">
        <Layout style="height:100%;">
          <Sider width="280" :style="{background: '#fff'}">
            <Card :bordered="false" dis-hover>
              <CellGroup style="margin-bottom:20px;">
                <div class="cell-group-title">
                  Operator Controls
                  <span v-if="operator">{{operator.callerId}}</span>
                </div>
                <Cell title="Connect to speaker room">
                  <i-switch
                    v-model="isOperatorConnectedToSpeakerRoom"
                    size="small"
                    slot="extra"
                    @on-change="toggleOperatorSpeakerRoomConnection"
                  />
                </Cell>
                <Cell title="Connected to audio toom">
                  <i-switch
                    v-model="isOperatorConnected"
                    size="small"
                    slot="extra"
                    @on-change="toggleOperatorConnection"
                  />
                </Cell>
                <Cell title="Un Muted">
                  <i-switch
                    v-model="isOperatorUnMuted"
                    size="small"
                    slot="extra"
                    @on-change="toggleOperatorMute"
                  />
                </Cell>
              </CellGroup>
              <CellGroup style="margin-bottom:20px;">
                <div class="cell-group-title">Meeting Controls</div>
                <Cell title="Hold All">
                  <i-switch v-model="switchValue" size="small" slot="extra" />
                </Cell>
                <Cell title="Recording">
                  <i-switch
                    v-model="audioRoom.isRecording"
                    size="small"
                    slot="extra"
                    type="error"
                    @on-change="toggleRecording"
                  />
                </Cell>
                <Button @click="openAudioFilesModal()">Audio Files</Button>
              </CellGroup>
              <CellGroup>
                <div class="cell-group-title">Downloads</div>
                <Cell title="Participant List"></Cell>
                <Cell title="Recording"></Cell>
              </CellGroup>
            </Card>
          </Sider>
          <Content>
            <h3 style="padding:16px;">Speakers {{audioRoom.speakerPinCode}}#</h3>
            <AudioRoomParticipants
              @connectToParticipant="connectToParticipant"
              :pinCode="audioRoom.speakerPinCode"
            ></AudioRoomParticipants>
            <h3 style="padding:16px;">Participants {{audioRoom.pinCode}}#</h3>
            <AudioRoomParticipants
              @connectToParticipant="connectToParticipant"
              :pinCode="audioRoom.pinCode"
            ></AudioRoomParticipants>
          </Content>
          <Modal :value="audioFilesModal" title="Audio Files">
            <Form :model="audioFilesFormData">
              <FormItem label="Waiting Music">
                <Upload
                  :action="uploadServer"
                  :on-success="handleWaitingMusicUpload"
                  :format="['mp3','m4a']"
                  :max-size="10000"
                >
                  <Button icon="ios-cloud-upload-outline">Upload</Button>
                </Upload>
              </FormItem>
              <FormItem label="Welcome Message">
                <Upload
                  :action="uploadServer"
                  :on-success="handleWelcomeMessageUpload"
                  :format="['mp3','m4a']"
                  :max-size="10000"
                >
                  <Button icon="ios-cloud-upload-outline">Upload</Button>
                </Upload>
              </FormItem>
            </Form>

            <div class="footer" slot="footer">
              <div class="actions">
                <Button type="info" @click="saveAudioFiles">Save</Button>
                <Button type="error" @click="audioFilesModal=false">Close</Button>
              </div>
            </div>
          </Modal>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import MgnNavbar from "@/components/base/MgnNavbar.vue";
import AudioRoomParticipants from "@/components/webcast/selfService/AudioRoomParticipants.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import axios from "axios";
import $config from "@/config";

export default {
  components: {
    MgnNavbar,
    AudioRoomParticipants
  },
  data() {
    return {
      switchValue: true,
      operatorCallSid: null,
      isOperatorConnected: false,
      isOperatorConnectedToSpeakerRoom: false,
      isOperatorUnMuted: false,
      isMeetingRecording: false,
      isPageReady: false,
      outgoingConnection: null,
      device: null,
      audioFilesFormData: null,
      audioFilesModal: false
    };
  },
  computed: {
    ...mapGetters("current", {
      current: "get"
    }),
    webcast() {
      return this.current("webcast");
    },
    audioRoom() {
      return this.current("audio-room");
    },
    ...mapGetters("audio-participants", {
      findParticipantsInStore: "find"
    }),
    operator() {
      let operatorRecord = this.findParticipantsInStore({
        query: {
          isOnCall: true,
          callSid: this.operatorCallSid
        }
      }).data[0];

      console.log(operatorRecord);

      if (operatorRecord && operatorRecord != null) {
        console.log(operatorRecord);
        this.isOperatorConnected = operatorRecord.isOnCall;
        this.isOperatorUnMuted = !operatorRecord.isMuted;
      }

      return operatorRecord;
      /*
      if(this.operatorCallSid){
        let operatorRecord = this.findParticipantsInStore({
          query: {
            isOnCall: true,
            callSid: this.operatorCallSid
          }
        }).data[0]
        if(operatorRecord) return operatorRecord
        else return {isOnCall: false, callerId: ''}
      } else {
        return {isOnCall: false, callerId: ''}
      }
      */
    },
    uploadServer() {
      return $config.uploadServer;
    }
  },
  methods: {
    ...mapActions("current", {
      setCurrent: "set"
    }),
    ...mapActions("webcast", {
      getWebcast: "get"
    }),
    ...mapActions("audio-room", {
      getAudioRoomAction: "get",
      updateAudioRoomAction: "patch"
    }),
    ...mapActions("audio-participants", {
      findParticipantsAction: "find",
      updateParticipantAction: "patch",
      createParticipantAction: "create"
    }),
    startWowzaRecording(webcastId) {
      axios
        .post($config.twilioBaseUrl + "/startWowzaRecordingRequest", {
          webcastId: webcastId
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.$Message.error(
            "An Error Occured <br/> Can't start to recording"
          );
        });
    },
    /*
    startAudioRoom() {
      console.log("Starting the audio roo");
      axios
        .post($config.twilioBaseUrl + "/startAudioRoom", {
          callSid: this.operator.callSid,
          roomId: this.audioRoom._id
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("An Error Occured <br/> Can't start to meeting");
        });
    },
    
    */
    initRoom() {
      this.updateAudioRoomAction([
        this.audioRoom._id,
        {
          status: "upcoming"
        }
      ]);
    },
    startAudioRoom() {
      console.log("Starting the audio room");
      axios
        .post($config.twilioBaseUrl + "/startAudioRoom", {
          callSid: this.operator.callSid,
          roomId: this.audioRoom._id
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("An Error Occured <br/> Can't start to meeting");
        });
    },
    toggleHoldAudioRoom() {
      console.log("Changing hold status currently: " + this.audioRoom.status);
      axios
        .post($config.twilioBaseUrl + "/toggleHoldAudioRoom", {
          roomId: this.audioRoom._id
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("An Error Occured <br/> Can't change hold state");
        });
    },
    endAudioRoom() {
      console.log("Ending the audio room");
      axios
        .post($config.twilioBaseUrl + "/endAudioRoom", {
          roomId: this.audioRoom._id,
          callSid: this.operator.callSid
        })
        .then(res => {
          console.log(res);
          this.$Message.success("Meeting ended");
        })
        .catch(err => {
          console.log(err);
          this.$Message.error(
            "An Error Occured <br/> Can't change meeting status"
          );
        });
    },
    connectSpeakers() {
      axios
        .post($config.twilioBaseUrl + "/speakersToConference", {
          roomId: this.audioRoom._id
        })
        .then(res => {
          console.log(res);
          this.$Message.success("Speakers has been connected");
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("An Error Occured <br/> Can't connect speakers");
        });
    },
    disconnectSpeakers() {
      axios
        .post($config.twilioBaseUrl + "/ConferenceToSpeakers", {
          roomId: this.audioRoom._id
        })
        .then(res => {
          console.log(res);
          this.$Message.success("Speakers has been disconnected");
        })
        .catch(err => {
          console.log(err);
          this.$Message.error(
            "An Error Occured <br/> Can't disconnect speakers"
          );
        });
    },
    toggleOperatorConnection(val) {
      console.log(val);
      console.log(this.audioRoom.conferenceSid);
      this.createTwilioConnection();
      if (val) {
        this.connectToAudioRoom("audioRoom");
      } else {
        this.disconnectToAudioRoom("audioRoom");
      }
    },
    toggleOperatorSpeakerRoomConnection(val) {
      console.log(val);
      console.log(this.audioRoom.conferenceSid);
      this.createTwilioConnection();
      if (val) {
        this.connectToAudioRoom("speaker");
      } else {
        this.disconnectToAudioRoom("speaker");
      }
    },
    connectToAudioRoom(room) {
      if (this.device) {
        let pinCode = this.audioRoom.pinCode;
        if (room == "speaker") {
          pinCode = this.audioRoom.speakerPinCode;
        }
        console.log("operatorConnection Pin Code: " + pinCode);
        var params = {
          from: "operator",
          confName: pinCode,
          Operator: true,
          BaseUrl: $config.twilioBaseUrl + "/",
          PinCode: pinCode,
          WebcastId: this.webcast._id
        };
        console.log(params);

        this.outgoingConnection = this.device.connect(params);
        console.log(this.outgoingConnection.parameters.CallSid);
        this.outgoingConnection.on("ringing", function() {
          console.log("Operator Connecting to Meeting Room");
        });
        this.outgoingConnection.on("connect", function() {
          console.log("Operator Connected");
          if (room == "speaker") {
            this.isOperatorConnectedToSpeakerRoom = true;
          } else {
            this.isOperatorConnected = true;
          }
        });
      }
    },
    disconnectToAudioRoom() {
      if (this.device) {
        this.device.disconnectAll();
        this.isOperatorConnected = false;
        this.isOperatorConnectedToSpeakerRoom = false;
      }
    },
    toggleOperatorMute() {
      let nextState = false;

      if (this.isOperatorUnMuted) nextState = false;
      else nextState = true;

      axios
        .post($config.twilioBaseUrl + "/toggleMuteParticipant", {
          callSid: this.operator.callSid,
          conferenceSid: this.audioRoom.conferenceSid,
          isMuted: nextState
        })
        .then(res => {
          console.log(res);
        });
    },
    toggleRecording() {
      let nextState = false;
      if (this.isMeetingRecording) {
        nextState = false;
      } else {
        nextState = true;
      }
      console.log(this.meeting);
      axios
        .post($config.twilioBaseUrl + "/toggleRecording", {
          conferenceSid: this.audioRoom.conferenceSid,
          isRecording: nextState
        })
        .then(res => {
          console.log(res);
          /*
        this.updateMeetingAction([this.meeting._id, {
          'isRecording': nextState
        }]).then((res2)=>{
          console.log(res2);
        })
        */
        });
    },

    connectToParticipant(p) {
      this.createTwilioConnection();
      this.connectedParticipant = p;
      if (this.connectedParticipant != null) {
        axios
          .post($config.twilioBaseUrl + "/connectToParticipant", {
            participantCallSid: p.callSid,
            operatorCallSid: this.operatorCallSid,
            conferenceSid: this.audioRoom.conferenceSid,
            baseUrl: $config.twilioBaseUrl,
            pinCode: this.audioRoom.pinCode
          })
          .then(res => {
            console.log(res);
          });
      } else {
        this.disconnectToAudioRoom();
        this.connectedParticipant = null;
        this.connectToAudioRoom();
      }
    },
    createTwilioConnection() {
      if (this.device) {
        return;
      }
      axios
        .post("https://veronica-prawn-8299.twil.io/capability-token", {
          role: "operator"
        })
        .then(res => {
          console.log(res.data);
          console.log("Token: " + res.data.token);

          // Setup Twilio.Device
          this.device = new Twilio.Device(res.data.token, {
            codecPreferences: ["opus", "pcmu"],
            fakeLocalDTMF: true,
            enableRingingState: true
          });

          this.device.on("ready", device => {
            console.log("Twilio.Device Ready!");
            //document.getElementById('call-controls').style.display = 'block';
          });

          this.device.on("error", function(error) {
            console.log("Twilio.Device Error: " + error.message);
          });

          this.device.on("connect", conn => {
            console.log("Successfully established call!");
            console.log(conn);
            this.$data.operatorCallSid = conn.parameters.CallSid;
            /*
          this.createParticipantAction({
            pinCode: this.audioRoom.pinCode,
            callSid: conn.parameters.CallSid,
            isOnCall: false,
            role: 'Operator',
            isMuted: true
          }).then((p)=>{
            console.log(p);
          });
          */

            //document.getElementById('button-call').style.display = 'none';
            //document.getElementById('button-hangup').style.display = 'inline';
            //volumeIndicators.style.display = 'block';
            //bindVolumeIndicators(conn);
          });

          this.device.on("disconnect", conn => {
            console.log("Call ended.");
            this.$set(this.$data, "operatorCallSid", null);
            //document.getElementById('button-call').style.display = 'inline';
            //document.getElementById('button-hangup').style.display = 'none';
            //volumeIndicators.style.display = 'none';
          });

          this.device.on("incoming", function(conn) {
            console.log("Incoming connection from " + conn.parameters.From);
            // accept the incoming connection and start two-way audio
            conn.accept();
          });

          //setClientNameUI(data.identity);

          //this.device.audio.on('deviceChange', updateAllDevices.bind(device));

          // Show audio selection UI if it is supported by the browser.
          if (this.device.audio.isOutputSelectionSupported) {
            //document.getElementById('output-selection').style.display = 'block';
          }
        })
        .catch(function(err) {
          console.log(err);
          console.log("Could not get a token from server!");
        });
    },
    openAudioFilesModal() {
      this.audioFilesModal = true;
    },
    handleWaitingMusicUpload(res, file) {
      console.log(res);
      console.log(file);
      this.audioFilesFormData.waitingAudioUrl = res;
    },
    handleWelcomeMessageUpload(res, file) {
      console.log(res);
      console.log(file);
      this.audioFilesFormData.welcomeMessageUrl = res;
    },
    saveAudioFiles() {
      console.log(this.audioRoom._id);
      this.updateAudioRoomAction([
        this.audioRoom._id,
        {
          waitingAudioUrl: this.audioFilesFormData.waitingAudioUrl,
          welcomeMessageUrl: this.audioFilesFormData.welcomeMessageUrl
        }
      ])
        .then(res => {
          console.log(res);
          this.$Message.success("Audio files has been saved");
        })
        .catch(err => {
          this.$Message.eror("Error saving audio files");
        });
    }
  },
  created() {
    //console.log(this.$store.state.auth.user);
    console.log("created");
    this.getWebcast(this.$router.currentRoute.params.id).then(wc => {
      console.log(wc);
      this.$store.commit("webcast/setCurrent", wc._id);
      this.setCurrent({
        service: "webcast",
        id: wc._id
      });
      console.log(this.webcast);
      if (this.webcast.hasAudioRoom) {
        console.log(this.webcast.audioRoomId);
        this.getAudioRoomAction(this.webcast.audioRoomId).then(room => {
          this.$store.commit("audio-room/setCurrent", room._id);
          this.setCurrent({
        service: "audio-room",
        id: room._id
      });
          this.isMeetingRecording = room.isRecording;
          this.audioFilesFormData = {
            waitingAudioUrl: room.waitingAudioUrl,
            welcomeMessageUrl: room.welcomeMessageUrl
          };

          /*
          this.findParticipantsAction({query:{
            $or:[
              {pinCode: this.audioRoom.pinCode},
              {pinCode: this.audioRoom.speakerPinCode}
            ]
          }}).then((response)=>{
            console.log(response);
            this.isPageReady = true;
          })
          */
          this.findParticipantsAction({
            query: {
              webcastId: this.audioRoom.webcastId
            }
          }).then(response => {
            console.log(response);
            this.isPageReady = true;
          });
        });
      }
    });
  }
};
</script>
<style lang="less" scoped>
@import "../../../less/mgn-variables.less";
.ivu-layout-sider {
  border-right: 1px solid @border-color;
}
.sub-header {
  position: fixed;
  top: 64px;
  border-bottom: 1px solid @border-color;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background-color: @white;
}
</style>
